module.exports = __webpack_public_path__ + "static/img/picc5.ed12fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picc5.png
// module id = Ll5H
// module chunks = 0